var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faTh } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PopupDefsHome from "./list-editor/popupdefsHome";
export var LayoutsListItem = function (_a) {
    var layoutKey = _a.layoutKey, layoutMeta = _a.layoutMeta;
    var location = useLocation();
    var state = location.state;
    var _b = useState((state === null || state === void 0 ? void 0 : state.isOpen) ? state === null || state === void 0 ? void 0 : state.isOpen : false), open = _b[0], setOpen = _b[1];
    //  NORMAL LAYOUT
    if (!layoutMeta.hasChildren) {
        return (_jsxs(Link, __assign({ to: "".concat(layoutKey), className: "panel-block flex items-center p-2 hover:bg-gray-200 border-b" }, { children: [_jsx(FontAwesomeIcon, { icon: faTh, className: "mr-2" }), layoutMeta.label] })));
    }
    //  POPUPDEFS PARENT
    return (_jsxs("div", __assign({ className: "border-b" }, { children: [_jsxs("div", __assign({ className: "panel-block flex items-center p-2 cursor-pointer hover:bg-gray-200", onClick: function () { return setOpen(!open); } }, { children: [_jsx(FontAwesomeIcon, { icon: faTh, className: "mr-2" }), layoutMeta.label] })), open && _jsx(PopupDefsHome, { layoutKey: layoutKey })] })));
};
